import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getVendorsQuery = () => {
  return axios.get(apiurl?.getVendorList);
};

const getVendorList = () => {
  return useQuery(['getvendorlist'], () => getVendorsQuery(), { refetchOnWindowFocus: false });
};

export default getVendorList;
